import { Route } from "vue-router";

// Old addresses of a "set your password" page that had no way to do it: a
// password is set from the invitation link (/confirmation) or the reset link
// (/reset_password). A token in the URL is passed on to the right one;
// without a token, the page where a new link is sent.
export function toPasswordFlow(to: Route) {
  const { token, confirmation_token } = to.query;
  if (confirmation_token) {
    return { name: "confirmation", query: { confirmation_token } };
  }
  if (token) return { name: "reset_password", query: { token } };
  return { name: "forgot_password" };
}

const routes = [
  {
    path: "/login",
    component: () => import(/* webpackChunkName: "auth" */ "views/Login.vue"),
    name: "login",
    meta: { noAuth: true },
  },
  {
    path: "/confirmation",
    component: () =>
      import(/* webpackChunkName: "auth" */ "views/Password/Confirmation.vue"),
    name: "confirmation",
    meta: { noAuth: true },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import(/* webpackChunkName: "auth" */ "views/Logout.vue"),
    meta: { role: ["anyone"] },
  },
  {
    path: "/forgot_password",
    component: () =>
      import(/* webpackChunkName: "auth" */ "views/Password/Forgot.vue"),
    name: "forgot_password",
    meta: { noAuth: true },
  },
  {
    path: "/reset_password",
    component: () =>
      import(/* webpackChunkName: "auth" */ "views/Password/Reset.vue"),
    name: "reset_password",
    meta: { noAuth: true },
  },
  {
    path: "/set_password",
    name: "set_password",
    redirect: toPasswordFlow,
  },
];

export default routes;
